module.exports = __webpack_public_path__ + "static/media/scroll-right-thin2.cdad7249.png";